export default __webpack_public_path__ + "static/media/PFS-Edited-Video-WEBMCOMPRESSED.960d64a0.webm";